import { checkEmpty, imageAddress } from 'data/helpers'
import PhysicianPlaceholderImage from 'static/images/profile-image-placeholder.jpg'

export const getSpecialty = (specialty, subspecialty) => {
  return subspecialty ? `${specialty}: ${subspecialty}` : specialty
}

export const getPhysicianProfileImage = profileImage => {
  const { key, fileName } = checkEmpty(profileImage) ? {} : profileImage
  return !checkEmpty(key) ? imageAddress(key, fileName) : PhysicianPlaceholderImage
}
